import { render, staticRenderFns } from "./InfoPm.vue?vue&type=template&id=f7f37eec&scoped=true&"
import script from "./InfoPm.vue?vue&type=script&lang=js&"
export * from "./InfoPm.vue?vue&type=script&lang=js&"
import style0 from "./InfoPm.vue?vue&type=style&index=0&id=f7f37eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f37eec",
  null
  
)

export default component.exports